import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { SchemaPropertyNode } from "../../../components/SchemaPropertyNode";
import { UUID } from 'angular2-uuid';
import { EntityConfigurationService } from "../../../entity-services/features/entityConfiguration/entity-configuration.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
declare var $: any;
@Component({
  selector: 'app-entity-type-definition',
  template: `
<button  class="btn btn-info btn-sm" (click)="OpenAddEntity(addEnitySchema)">Add Schema</button>
<!-- Modal for Add Rlation-->
<ng-template #addEnitySchema let-c="close" let-d="dismiss">
  
  <div class="modal-header">
    <h6 class="modal-title">Add Entity Schema</h6>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
 
  <div class="modal-body">
    <div class="container-fluid">   
      <div class="row">
        <div class="col-md-3">
          <label for="lblRelationName">Schema Name:</label>
        </div>
        <div class="col-md-3">
          <input class="form-control" [(ngModel)]="entityTypeName" type="text">
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <app-entity-schema-editor [root]="rootSchemaNode"></app-entity-schema-editor>

        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-md" (click)="addEntityType();c('Close click');">Save</button>
    <button type="button" class="btn btn-outline-dark btn-md" (click)="onCloseEntityTypeDefinitionDialog();c('Close click');">Close</button>
  </div>
</ng-template>`,
  styles: [``]
})
export class EntityTypeDefinitionComponent implements OnInit {
  entityTypeName: string;
  schemaTitle: string;
  rootSchemaNode: SchemaPropertyNode = new SchemaPropertyNode();
  @Output() addSchema: EventEmitter<any> = new EventEmitter<any>();
  constructor(private modalService: NgbModal,
    private toastr:ToastsManager, private entityConfigurationService: EntityConfigurationService) { }

  ngOnInit() {

  }
  addEntityType() {
    console.log(this.rootSchemaNode);
    let schemaData = this.rootSchemaNode;
    let finalSchema = schemaData.getSchema();
    finalSchema["title"] = this.entityTypeName;
   console.log(JSON.stringify(finalSchema));
    this.entityConfigurationService.saveSchema([finalSchema]).subscribe(res=>{
      this.addSchema.emit(finalSchema);
      this.toastr.success('Entity Schema saved successfully!', 'Success!');
      this.onCloseEntityTypeDefinitionDialog();
    },error=>{
      this.toastr.error(error, 'Error!');
      
    })
   
  }
  onCloseEntityTypeDefinitionDialog() {
    this.rootSchemaNode = new SchemaPropertyNode();
  }
  
  OpenAddEntity(content) {
    this.modalService.open(content, { size: "lg", backdrop: "static", windowClass: "adminModalResiable" }).result.then((result) => {

    }, (reason) => {

    }, );
  }

}
